import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Button,
  Container,
  InputBase,
  Grid,
  useMediaQuery,
  LinearProgress,
  linearProgressClasses,
} from "@mui/material";
import { usePresaleContract } from "../ConnectivityAss/hooks";
import logo from "../images/b.png";
import bnbLogo from "../images/bnblogo.svg";
import Loading from "../loading";
import { toast } from "react-toastify";
import { AppContext } from "../utils";
import { parseUnits } from "@ethersproject/units";
import TimerCountDown from "../Timer";
import { styled } from "@mui/styles";

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  width: "100%",
  borderRadius: 0,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#d1d1d1",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 0,
    backgroundColor: "#01cfed",
  },
}));

function Presale() {
  const { account, signer } = useContext(AppContext);
  const preSaleContract = usePresaleContract(signer);
  const matches = useMediaQuery("(max-width:700px)");
  const [amount, setamount] = useState("");
  const [tokens, settokens] = useState("0");
  const [loading, setloading] = useState(false);
  const [hardCap, sethardCap] = useState(4000);
  const [sold, setsold] = useState(0);
  const [progress, setprogress] = useState(0);

  const init = async () => {
    try {
      let tokenReceive = 348 * +amount;
      settokens(tokenReceive);
      console.log(tokenReceive, "tokenReceive");
    } catch (error) {}
  };
  useEffect(() => {
    if (amount) {
      init();
    }
  }, [amount]);
  // useEffect(() => {
  //   const initSoftCap = async () => {
  //     try {
  //       const softCap = await preSaleContract.amountRaised();
  //       let raised = +formatUnits(softCap.toString());
  //       let prog = (+raised / +hardCap) * 100;
  //       setsold(raised);
  //       setprogress(+prog);
  //     } catch (error) {}
  //   };
  //   initSoftCap();
  // }, []);
  const buyHadler = async () => {
    if (account) {
      if (!amount) {
        toast.error("Error! Please enter a amount");
      } else if (isNaN(amount) || +amount < 0) {
        toast.error("Error! Please enter a valid amount");
      } else if (+amount == 0) {
        toast.error("Error!  Please enter a valid amount");
      } else if (+amount > 0 && +amount < 0.01) {
        toast.error("Error! Minimum amount is 0.01 BNB");
      } else if (+amount !== 0 && +amount > 400) {
        toast.error("Error! Maximum amount is 400 BNB");
      } else {
        try {
          setloading(true);
          console.log(
            parseUnits(amount.toString()).toString(),
            "parseUnits(amount.toString())"
          );
          const tx = await preSaleContract.buyTokens(account, {
            value: parseUnits(amount.toString()).toString(),
          });
          await tx.wait();
          toast.success("Success! Transaction confirmed.");
          setloading(false);
          window.location.reload();
        } catch (error) {
          setloading(false);
          if (error?.data?.message) {
            toast.error(error?.data?.message);
          } else {
            toast.error(error?.message);
          }
        }
      }
    } else {
      toast.error("Error! Please connect your wallet.");
    }
  };

  return (
    <Box pt={5} pb={10} position="relative" zIndex={1}>
      <Loading loading={loading} />

      <Container maxWidth="md">
        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <Box
            mb={2}
            fontWeight="700"
            fontSize="20px"
            color="#ffffff"
            fontFamily="Secular One"
            textAlign="center"
        >

          </Box>

          <Grid mt={5} container spacing={5}>
            <Grid item xs={12} sm={12} md={6}>
              <Box
                width="100%"
                height="100%"
                boxShadow="#01cfed 0px 0px 20px 3px"
                style={{
                  background: "rgb(25 25 24)",
                }}
                borderRadius="0px"
                borderTop="20px solid #"
                borderBottom="20px solid #"
                borderLeft="10px solid #"
                borderRight="10px solid #"
                display="flex"
                flexDirection="column"
                p={2}
              >
                <Box
                  fontWeight="700"
                  fontSize="25px"
                  color="#ffffff"
                  fontFamily="Secular One"
                  textAlign="center"
                >
                  Buy LOIS
                </Box>

                <Box
                  mt={2}
                  mb={2}
                  style={{
                    boxShadow: "#01cfed 0px 0px 8px 1px",
                    background: "transparent",
                    paddingLeft: 15,
                    borderRadius: "0px",
                  }}
                  pb={2}
                  pt={1}
                >
                  <Box
                    style={{
                      color: "#ffffff",
                      fontFamily: "Chakra Petch",
                      fontWeight: "500",
                      fontSize: "18px",
                      marginTop: "10px",
                      width: "100%",
                      paddingRight: "15px",
                      textAlign: "left",
                    }}
                  >
                    {" "}
                    From:{" "}
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="space-beteen"
                    alignItems="center"
                  >
                    <InputBase
                      style={{
                        color: "#ffffff",
                        fontFamily: "Chakra Petch",
                        fontWeight: "600",
                        fontSize: "18px",
                        marginTop: "10px",
                        width: "100%",
                        paddingRight: "15px",
                      }}
                      fullWidth
                      type="text"
                      id="standard-basic"
                      variant="standard"
                      placeholder="Enter BNB"
                      value={amount}
                      onChange={(e) => {
                        setamount(e.target.value);
                      }}
                    />
                    <Box
                      display="flex"
                      alignItems="center"
                      borderRadius="0px"
                      height={matches ? "35px" : "auto"}
                      pl={matches ? 1 : 3}
                      pr={matches ? 2 : 4}
                      py={1}
                      mr={2}
                      style={{
                        color: "#ffffff",
                        fontFamily: "Chakra Petch",
                        fontWeight: "500",
                        fontSize: "16px",
                        marginTop: "10px",
                        background: "transparent",
                        boxShadow: "#01cfed 0px 0px 8px 1px",
                        borderBottom: "5px solid #",
                      }}
                    >
                      {" "}
                      <img
                        style={{ marginRight: "5px", marginBottom: "3px" }}
                        width="25px"
                        height="25px"
                        src={bnbLogo}
                        alt=""
                      />{" "}
                      BNB
                    </Box>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                  style={{
                    boxShadow: "#01cfed 0px 0px 8px 1px",
                    backgroundColor: "transparent",
                    borderRadius: "0px",
                    marginTop: 10,
                  }}
                  py={2}
                  px={2}
                >
                  <Box
                    mb={1}
                    style={{
                      color: "#ffffff",
                      fontFamily: "Chakra Petch",
                      fontWeight: "500",
                      fontSize: "18px",
                      width: "100%",
                      paddingRight: "15px",
                      textAlign: "left",
                    }}
                  >
                    {" "}
                    To:{" "}
                  </Box>

                  <Box
                    alignItems="center"
                    justifyContent="space-between"
                    display="flex"
                  >
                    <span
                      style={{
                        fontSize: "18px",
                        color: "#ffffff",
                        fontFamily: "Chakra Petch",
                      }}
                      className="heading"
                    >
                      {tokens}
                    </span>
                    <Box
                      display="flex"
                      alignItems="center"
                      borderRadius="0px"
                      height={matches ? "35px" : "auto"}
                      pl={matches ? 1 : 3}
                      pr={matches ? 2 : 4}
                      py={1}
                      style={{
                        color: "#ffffff",
                        fontFamily: "Chakra Petch",
                        fontWeight: "500",
                        fontSize: "16px",
                        marginTop: "10px",
                        boxShadow: "#01cfed 0px 0px 8px 1px",
                        background: "transparent",
                        borderBottom: "5px solid #",
                      }}
                    >
                      {" "}
                      <img
                        style={{ marginRight: "5px", marginBottom: "3px" }}
                        width="20px"
                        height="20px"
                        src={logo}
                        alt=""
                      />{" "}
                      LOIS
                    </Box>
                  </Box>
                </Box>

                <Box mt={5} display="flex" flexDirection="column">
                  <Box textAlign="center" width="100%">
                    <Button
                      style={{
                        background: "transparent",
                        background: "transparent",
                        boxShadow: "#01cfed 0px 0px 8px 1px",
                        fontSize: "18px",
                        borderRadius: "0px",
                        width: "176px",
                        height: "45px",
                        color: "#ffffff",
                        textTransform: "capitalize",
                        fontWeight: "500",
                        borderBottom: "5px solid #",
                      }}
                      onClick={() => buyHadler()}
                    >
                      Buy
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <Box
                width="100%"
                height="100%"
                boxShadow="#01cfed 0px 0px 20px 3px"
                style={{
                  background: "rgb(25, 25, 24)",
                }}
                borderRadius="0px"
                display="flex"
                flexDirection="column"
                borderTop="20px solid #"
                borderBottom="20px solid #"
                borderLeft="10px solid #"
                borderRight="10px solid #"
                p={2}
              >
                {/* <BorderLinearProgress
                  style={{ height: 20, marginTop: 10 }}
                  variant="determinate"
                  value={progress}
                />
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box
                    fontFamily="Secular One"
                    fontSize="15px"
                    fontWeight={700}
                    color="#ffffff"
                  >
                    {parseFloat(+sold).toFixed(4)} BNB
                  </Box>
                  <Box
                    fontFamily="Secular One"
                    fontSize="15px"
                    fontWeight={700}
                    color="#ffffff"
                  >
                    {" "}
                    {hardCap} BNB
                  </Box>
                </Box> */}
                <Box
                  fontWeight="700"
                  fontSize="25px"
                  color="#ffffff"
                  fontFamily="Secular One"
                  textAlign="center"
                >
                  Token Info
                </Box>
                <Box
                  mt={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom="1px solid #01cfed"
                  pb={2}
                >
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    Token Name
                  </Box>
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    LOIS
                  </Box>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom="1px solid #01cfed"
                  pb={2}
                  mt={2}
                >
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    Token Symbol
                  </Box>
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    LOIS
                  </Box>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom="1px solid #01cfed"
                  pb={2}
                  mt={2}
                >
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    Token Decimals
                  </Box>
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    18
                  </Box>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom="1px solid #01cfed"
                  pb={2}
                  mt={2}
                >
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    Tokens Price
                  </Box>
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    0.91 usdt
                  </Box>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom="1px solid #01cfed"
                  pb={2}
                  mt={2}
                >
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    Min Contribute
                  </Box>
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    0.01 BNB{" "}
                  </Box>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom="1px solid #01cfed"
                  pb={2}
                  mt={2}
                >
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    Max Contribute
                  </Box>
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    400 BNB{" "}
                  </Box>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom="1px solid #01cfed"
                  pb={2}
                  mt={2}
                >
                  <Box
                    fontWeight="600"
                    borderRadius="8px"
                    fontSize="16px"
                    color="#ffffff"
                    fontFamily="Chakra Petch"
                  >
                    Token Contract
                  </Box>
                  <a
                    href="https://bscscan.com/token/0xad09104083d182d067cae2a123c6f1b052d2ea42"
                    target="_blank"
                    style={{ textDecoration: "none" }}
                  >
                    <Box
                      fontWeight="600"
                      borderRadius="8px"
                      fontSize="16px"
                      color="#ffffff"
                      fontFamily="Chakra Petch"
                    >
                      0xad09..2eA42
                    </Box>
                  </a>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}

export default Presale;
